var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsArray, IsEnum, IsUUID } from 'class-validator';
import { PreventionCourseState } from '../enum/prevention-course-module-state.js';
export class PreventionCourseTrackings {
    id;
    state;
    modules;
}
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], PreventionCourseTrackings.prototype, "id", void 0);
__decorate([
    Expose(),
    IsEnum(PreventionCourseState),
    __metadata("design:type", String)
], PreventionCourseTrackings.prototype, "state", void 0);
__decorate([
    IsArray(),
    Expose(),
    __metadata("design:type", Array)
], PreventionCourseTrackings.prototype, "modules", void 0);
//# sourceMappingURL=prevention-course-trackings.dto.js.map